export default "__VITE_ASSET__9c44185a__"